/* eslint-disable */
import { Component } from "react";

type NavigationItemBaseProps = {
  active?: $TSFixMe;
  translationKey?: string;
  className?: string;
  isExternalLink?: boolean;
  externalLinkTargetName?: string;
};

type NavigationItemWithTarget = NavigationItemBaseProps & {
  target: string;
  onClick?: never;
};

type NavigationItemWithOnClick = NavigationItemBaseProps & {
  target?: never;
  isExternalLink?: never;
  /**
   *
   * @remarks
   * When using `onClick`, you need to handle the navigation manually.
   *
   * This variant doesn't accept a `target` property as navigation is entirely controlled by the `onClick` handler.
   *
   * onClick has no effect using it with `isExternalLink`.
   */
  onClick: () => void;
};

type NavigationItemProps = NavigationItemWithTarget | NavigationItemWithOnClick;

const defaultProps: Partial<
  Omit<NavigationItemBaseProps, "target" | "onClick">
> = {
  className: "",
};

type Props = NavigationItemProps & typeof defaultProps;

class NavigationItem extends Component<Props> {
  static componentName = "NavigationItem";

  static readonly defaultProps = defaultProps;
}

export default NavigationItem;
